export default __webpack_public_path__ + "static/media/otpPreference.b13fc26d.svg";